// extracted by mini-css-extract-plugin
module.exports = {"link":"navigation_link__ySOQS","activeLink":"navigation_activeLink__qJwhN"};